









import Vue from "vue";
import { SearchAPIModels } from "search-api-client";

export default Vue.extend({
  name: "FilterDropDown",
  props: {
    name: {
      type: String,
      required: true,
      default: "",
    },
    open: {
      type: Boolean,
    },
    options: {
      type: Array as () => SearchAPIModels.TaxonomyTag[],
      required: true,
      default: () => [],
    },
    active: {
      type: Array as () => SearchAPIModels.TaxonomyTag[],
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      selectedOption: null as SearchAPIModels.TaxonomyTag,
    };
  },
  computed: {
    tabIndex() {
      return this.active ? 0 : -1;
    },
  },
  watch: {
    selectedOption: function() {
      if (this.$data.selectedOption !== null) {
        const emitObject = {
          title: this.$data.selectedOption.title,
          id: this.$data.selectedOption.id,
          categoryId: this.$data.selectedOption.categoryId,
          count: this.$data.selectedOption.count,
        } as SearchAPIModels.TaxonomyTag;
        this.$emit("inputChange", emitObject);
        this.$data.selectedOption = null;
      }
    },
  },
  methods: {
    isChecked(id: string): boolean {
      return (
        this.$props.active
          .map(function(e: SearchAPIModels.TaxonomyTag) {
            return e.id;
          })
          .indexOf(id) > -1
      );
    },
    showCheckboxes() {
      this.$emit("toggleFilters");
    },
  },
});
